module.exports = __webpack_public_path__ + "static/media/version_control 2.bd6fb7a3.svg";